export default __webpack_public_path__ + "static/media/yellow.4f4b3e6c.svg";